import { fork, all, call, put } from 'redux-saga/effects';

import {
  watchGetToken,
  watchLoginUser,
  watchLoginSuccess,
  watchLogout,
  watchRefreshToken,
  watchRefreshTokenSuccess,
  watchRefreshTokenFailure,
  watchGetTokenFailure,
  watchSetUserRole,
  watchRequestPasswordResetRequest,
  watchResetPasswordRequest,
  watchResetPasswordSuccess,
  watchGetTokenSuccess,
  watchGetRoleManagementRepresentationRequest,
} from './Auth';

import {
  watchGetIncidentReportsRequest,
  watchDeleteIncidentReportsRequest,
  watchDeleteIncidentReportsSuccess,
} from './EMSUsageReports';

import { watchGetAppLogsRequest } from './AppLogs';

import {
  watchGetUsersRequest,
  watchGetActiveUsersRequest,
  watchGetInactiveUsersRequest,
  watchGetUserRequest,
  watchUpdateUserRequest,
  watchDeleteUserRequest,
  watchDeleteUserSuccess,
  watchUpdateUserSuccess,
  watchDeleteUsersRequest,
  watchDeleteUsersSuccess,
  watchCreateHomeUserRequest,
  watchCreateHomeUserSuccess,
  watchCreateStudioUserRequest,
  watchCreateStudioUserByAdminRequest,
  watchCreateStudioUserByAdminSuccess,
  watchCreateStudioUserSuccess,
  watchUpdateUserByAdminRequest,
  watchUpdateUserByAdminSuccess,
  watchUpdateUserCreditsRequest,
  watchUpdateUserCreditsSuccess,
  watchIsBeautyCareAdminRequest,
  watchGetActiveRentUsersRequest,
  watchGetInactiveRentUsersRequest,
  watchCreateRentalUserRequest,
  watchCreateRentalUserSuccess,
} from './User';

import {
  watchGetLicenseTemplatesRequest,
  watchGetLicenseTemplateRequest,
  watchUpdateLicenseTemplateRequest,
  watchUpdateLicenseTemplateSuccess,
  watchCreateLicenseTemplateRequest,
  watchCreateLicenseTemplateSuccess,
  watchDeleteLicenseTemplateRequest,
  watchDeleteLicenseTemplateSuccess,
  watchAssignLicenseRequest,
  watchAssignLicenseSuccess,
  watchCreateLicenseRequest,
  watchCreateLicenseSuccess,
  watchUpdateLicenseRequest,
  watchUpdateLicenseSuccess,
  watchGetLicensesRequest,
  watchGetLicenseRequest,
  watchAssignPoolLicenseRequest,
  watchAssignPoolLicenseSuccess,
  watchGetSharedLicensesRequest,
} from './License';

import {
  watchGetPowerboxListRequest,
  watchGetPowerboxRequest,
  watchAssignPowerboxRequest,
  watchDeletePowerboxRequest,
  watchDeletePowerboxSuccess,
  watchAssignPowerboxSuccess,
  watchCreatePowerboxRequest,
  watchCreatePowerboxSuccess,
  watchUpdatePowerboxRequest,
  watchUpdatePowerboxSuccess,
} from './Powerbox';

import {
  watchGetOrganizationListRequest,
  watchGetOrganizationsHierarchyRequest,
  watchGetOrganizationRequest,
  watchUpdateOrganizationRequest,
  watchDeleteOrganizationRequest,
  watchDeleteOrganizationSuccess,
  watchUpdateOrganizationSuccess,
  watchCreateOrganizationRequest,
  watchCreateOrganizationSuccess,
  watchGetOrganizationTypes,
  watchGetChildOranization,
  watchUpdateOrganizationByAdminRequest,
  watchUpdateOrganizationByAdminSuccess,
  watchGetActiveOrganizationsRequest,
  watchGetInactiveOrganizationsRequest,
} from './Organizations';

import {
  watchGetMembersRequest,
  watchGetMemberRequest,
  watchCreateMemberRequest,
  watchCreateMemberSuccess,
  watchUpdateMemberRequest,
  watchUpdateMemberSuccess,
  watchDeleteMemberRequest,
  watchDeleteMemberSuccess,
  watchGetRoles,
  watchDeleteMemberByAdminRequest,
  watchDeleteMemberByAdminSuccess,
  watchCreateMemberByAdminRequest,
  watchCreateMemberByAdminSuccess,
  watchUpdateMemberByAdminSuccess,
  watchUpdateMemberByAdminRequest,
  watchUpdateMemberPasswordRequest,
  watchUpdateMemberPasswordSuccess,
  watchGetActiveMembersRequest,
  watchGetInactiveMembersRequest,
} from './Members';

import {
  wathcGetBlacklistEntriesRequest,
  wathcGetBlacklistEntryRequest,
  watchMoveToBlacklistRequest,
  watchDeleteFromBlacklistSuccess,
  watchMoveToBlacklistSuccess,
  watchDeleteFromBlacklistRequest,
  wathcGetBlacklistLicenseRequest,
  wathcGetBlacklistPowerboxRequest,
} from './Blacklist';

// resuable fetch Subroutine
// entity :  user | repo | starred | stargazers
// apiFn  : api.fetchUser | api.fetchRepo | ...
export function* apiRequest(entity, apiFn, action) {
  const { id, data } = action;
  const { response, error } = id ? yield call(apiFn, id, data) : yield call(apiFn, data);
  if (!error) yield put(entity.success(response));
  else yield put(entity.failure(error));
}

export default function* root() {
  yield all([
    fork(watchGetToken),
    fork(watchLoginUser),
    fork(watchLoginSuccess),
    fork(watchGetTokenSuccess),
    fork(watchLogout),
    fork(watchRefreshToken),
    fork(watchRefreshTokenSuccess),
    fork(watchGetTokenFailure),
    fork(watchRefreshTokenFailure),
    fork(watchGetUsersRequest),
    fork(watchGetActiveUsersRequest),
    fork(watchGetInactiveUsersRequest),
    fork(watchGetUserRequest),
    fork(watchCreateHomeUserRequest),
    fork(watchCreateHomeUserSuccess),
    fork(watchCreateStudioUserRequest),
    fork(watchCreateStudioUserSuccess),
    fork(watchUpdateUserRequest),
    fork(watchDeleteUserRequest),
    fork(watchDeleteUserSuccess),
    fork(watchSetUserRole),
    fork(watchRequestPasswordResetRequest),
    fork(watchResetPasswordRequest),
    fork(watchResetPasswordSuccess),
    fork(watchUpdateUserSuccess),
    fork(watchDeleteUsersRequest),
    fork(watchDeleteUsersSuccess),
    fork(watchUpdateUserCreditsRequest),
    fork(watchUpdateUserCreditsSuccess),
    fork(watchUpdateUserByAdminSuccess),
    fork(watchUpdateUserByAdminRequest),
    fork(watchDeletePowerboxRequest),
    fork(watchDeletePowerboxSuccess),
    fork(watchGetPowerboxListRequest),
    fork(watchGetPowerboxRequest),
    fork(watchCreatePowerboxRequest),
    fork(watchAssignPowerboxSuccess),
    fork(watchAssignPowerboxRequest),
    fork(watchCreatePowerboxSuccess),
    fork(watchDeleteOrganizationRequest),
    fork(watchDeleteOrganizationSuccess),
    fork(watchGetOrganizationListRequest),
    fork(watchGetOrganizationRequest),
    fork(watchCreateOrganizationRequest),
    fork(watchUpdateOrganizationSuccess),
    fork(watchUpdateOrganizationRequest),
    fork(watchCreateOrganizationSuccess),
    fork(watchUpdateOrganizationByAdminSuccess),
    fork(watchUpdateOrganizationByAdminRequest),
    fork(watchGetOrganizationTypes),
    fork(watchGetChildOranization),
    fork(watchGetRoleManagementRepresentationRequest),
    fork(watchDeleteFromBlacklistRequest),
    fork(watchDeleteFromBlacklistSuccess),
    fork(watchMoveToBlacklistRequest),
    fork(watchMoveToBlacklistSuccess),
    fork(wathcGetBlacklistEntriesRequest),
    fork(wathcGetBlacklistEntryRequest),
    fork(wathcGetBlacklistPowerboxRequest),
    fork(wathcGetBlacklistLicenseRequest),
    fork(watchGetMembersRequest),
    fork(watchGetMemberRequest),
    fork(watchCreateMemberRequest),
    fork(watchCreateMemberSuccess),
    fork(watchUpdateMemberRequest),
    fork(watchUpdateMemberSuccess),
    fork(watchDeleteMemberRequest),
    fork(watchDeleteMemberSuccess),
    fork(watchGetRoles),
    fork(watchGetLicenseTemplatesRequest),
    fork(watchGetLicenseTemplateRequest),
    fork(watchUpdateLicenseTemplateRequest),
    fork(watchUpdateLicenseTemplateSuccess),
    fork(watchCreateLicenseTemplateRequest),
    fork(watchCreateLicenseTemplateSuccess),
    fork(watchDeleteLicenseTemplateRequest),
    fork(watchDeleteLicenseTemplateSuccess),
    fork(watchAssignLicenseRequest),
    fork(watchAssignLicenseSuccess),
    fork(watchGetLicensesRequest),
    fork(watchCreateLicenseRequest),
    fork(watchCreateLicenseSuccess),
    fork(watchGetLicenseRequest),
    fork(watchUpdateLicenseSuccess),
    fork(watchUpdateLicenseRequest),
    fork(watchGetSharedLicensesRequest),
    fork(watchAssignPoolLicenseRequest),
    fork(watchCreateStudioUserByAdminRequest),
    fork(watchCreateStudioUserByAdminSuccess),
    fork(watchAssignPoolLicenseSuccess),
    fork(watchDeleteMemberByAdminRequest),
    fork(watchDeleteMemberByAdminSuccess),
    fork(watchCreateMemberByAdminRequest),
    fork(watchCreateMemberByAdminSuccess),
    fork(watchUpdateMemberByAdminSuccess),
    fork(watchUpdateMemberByAdminRequest),
    fork(watchUpdateMemberPasswordRequest),
    fork(watchUpdateMemberPasswordSuccess),
    fork(watchUpdatePowerboxRequest),
    fork(watchUpdatePowerboxSuccess),
    fork(watchGetIncidentReportsRequest),
    fork(watchDeleteIncidentReportsRequest),
    fork(watchDeleteIncidentReportsSuccess),
    fork(watchIsBeautyCareAdminRequest),
    fork(watchGetAppLogsRequest),
    fork(watchGetOrganizationsHierarchyRequest),
    fork(watchGetActiveMembersRequest),
    fork(watchGetInactiveMembersRequest),
    fork(watchGetActiveOrganizationsRequest),
    fork(watchGetInactiveOrganizationsRequest),
    fork(watchGetActiveRentUsersRequest),
    fork(watchGetInactiveRentUsersRequest),
    fork(watchCreateRentalUserRequest),
    fork(watchCreateRentalUserSuccess),
  ]);
}
